import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { awsUrl, awsUrl2 } from "../../config";
import axios from "axios";

const TEXT_DETAILS = {
  approved: {
    header: "Congratulations!",
    body:
      process.env.REACT_APP_MODE === "beta"
        ? `To bind coverage, please email documentation to underwriting@insurecomp.com.`
        : `To bind coverage, please email documentation to underwriting@fubaworks.com.`,
    button: "Download Quote",
  },
  referred: {
    header: "Thank you for your submission",
    body:
      "This risk will need further review by one of our underwriters. Our underwriting team will respond within the next 24-48 hours.",
  },
  declined: {
    header: "Thank you for your submission",
    body: "",
    button: "Download Declination",
  },
};

function FubaQuoteDetails(props) {
  let listToDisplay = [];
  let indx = 0;
  const [loadingEAcord, setLoadingEAcord] = useState(false);
  const [warnMsg,setWarnMsg] =useState(false);


  for (let statement of props.statements) {
    listToDisplay.push(<li key={indx++}>{statement}</li>);
  }

const downloadEAcord = async () => {
  setWarnMsg(true);
  try {
    let eAcordPdf;
    let currProspect = sessionStorage.getItem("currProspect")
      ? JSON.parse(sessionStorage.getItem("currProspect"))
      : undefined;

    let address = sessionStorage.getItem("address")
      ? JSON.parse(sessionStorage.getItem("address"))
      : undefined;

    let quoteData = sessionStorage.getItem("quoteData")
      ? JSON.parse(sessionStorage.getItem("quoteData"))
      : undefined;

    let agentID = sessionStorage.getItem("agentID");

    let childrenLoc = currProspect.childrenLoc;
    let stateList = [];

    for (let childrenLocIndx in childrenLoc) {
      let childrenLocObj = childrenLoc[childrenLocIndx];
      if (childrenLocObj.state && childrenLocObj.state.value) {
        stateList.push(childrenLocObj.state.value.toLowerCase());
      }
    }

    let isLoggedIn;
    try {
      isLoggedIn = await Auth.currentAuthenticatedUser();
    } catch (error) {
      console.log("Authentication error here", error);
    }

    if (currProspect && address && quoteData) {
      let etQuoteDetails = {
        email: agentID,
        timestamp: quoteData.date,
        carrier: `carrier_ax`,
        mail_address: "",
        address: address,
        state: stateList,
        netRateMap: {},
        agent_name: isLoggedIn?.attributes.name || " ",
        agent_email: isLoggedIn?.attributes.email || " ",
        agent_agency: isLoggedIn?.attributes["custom:agency"] || " ",
        uw_name: isLoggedIn?.attributes["custom:uw"] || " ",
        agency_code: isLoggedIn?.attributes["custom:agency_code"] || "",
        acordType: "FL",
      };
      const postRes = await axios.post(
        awsUrl2 + "/api/postEAccordData",
        JSON.stringify(etQuoteDetails)
      );

      const { id } = postRes.data;
      if (!id) throw new Error("No ID received");

      let status = "PENDING";
      let s3_key = null;

      while (status === "PENDING" || status === "PROCESSING") {
        await new Promise((res) => setTimeout(res, 3000));

        const statusRes = await axios.get(
          `${awsUrl2}/api/getEAccordStatus?id=${id}`
        );

        status = statusRes.data.status;

        if (status === "COMPLETED") {
          s3_key = statusRes.data.s3_key;
        } else if (status === "FAILED") {
          throw new Error("Generation failed");
        }
      }

      const filename = "editable_acord.pdf";

      if (s3_key && s3_key.startsWith("http")) {
        const response = await fetch(s3_key);
        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (s3_key) {
        const uint8Array = new Uint8Array(
          atob(s3_key)
            .split("")
            .map((c) => c.charCodeAt(0))
        );

        const blob = new Blob([uint8Array], {
          type: "application/pdf",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      setLoadingEAcord(false);
      setWarnMsg(false);
    }
  } catch (error) {
    console.error("Error:", error);
    alert("Failed to download editable Acord. Please try again later.");
  }
};

  return (
    props.eligibility && (
      <div className="fuba-quote-details">
        <div className="text-center mb-3 fuba-quote-details-header">
          <b>{TEXT_DETAILS[props.eligibility]["header"]}</b>
        </div>
        <div className="fuba-quote-details-body">
          <div className="text-center">
            {TEXT_DETAILS[props.eligibility]["body"]}
          </div>
          {props.statements && (
            <div className="statements">
              <ul>{listToDisplay}</ul>
            </div>
          )}
        </div>
        <div className="downloadEAcord">
          {TEXT_DETAILS[props.eligibility]["button"] && (
            <div className="text-center">
              <button
                className="btn btn-warning"
                onClick={(e) => props.callback()}
              >
                {TEXT_DETAILS[props.eligibility]["button"]}
              </button>
            </div>
          )}
          <button
            className="btn btn-primary"
            onClick={() => {
              downloadEAcord();
              setLoadingEAcord(true);
            }}
          >
            {loadingEAcord ? "Downloading..." : "Download EAcord"}
          </button>
        </div>
            { warnMsg && (
           <div className="showmessage text-600">
                  <table className="text-center" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td>
                          <div style={{ Width: "100%", margin: "0 auto", textAlign: "center",padding:"5 px"}}>
                            <p>
                              <span className="msgicon">⚠️</span>
                              Recommended Browser: For optimal performance with the E-Acord, please use  
                               <p className="innerMsg">
                             Google Chrome.Some features may not work as expected in other browsers.
                            </p>
                            </p>
                           
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

          )}
      </div>
    )
  );
}

export default FubaQuoteDetails;
